import { createTheme } from '@mui/material/styles';

// colors
import { colors } from '../colors';

// breakpoints
import { breakpoints } from './breakpoints';

// fonts
import ManropeExtraLightTtf from './fonts/Manrope-ExtraLight.ttf';
import ManropeLightTtf from './fonts/Manrope-Light.ttf';
import ManropeRegularTtf from './fonts/Manrope-Regular.ttf';
import ManropeMediumTtf from './fonts/Manrope-Medium.ttf';
import ManropeSemiBoldTtf from './fonts/Manrope-SemiBold.ttf';
import ManropeBoldTtf from './fonts/Manrope-Bold.ttf';
import ManropeExtraBoldTtf from './fonts/Manrope-ExtraBold.ttf';

import SourceSerifProExtraLightTtf from './fonts/SourceSerifPro-ExtraLight.ttf';
import SourceSerifProExtraLightItalicTtf from './fonts/SourceSerifPro-ExtraLightItalic.ttf';
import SourceSerifProLightTtf from './fonts/SourceSerifPro-Light.ttf';
import SourceSerifProLightItalicTtf from './fonts/SourceSerifPro-LightItalic.ttf';
import SourceSerifProRegularTtf from './fonts/SourceSerifPro-Regular.ttf';
import SourceSerifProItaliccTtf from './fonts/SourceSerifPro-Italic.ttf';
import SourceSerifProSemiBoldTtf from './fonts/SourceSerifPro-SemiBold.ttf';
import SourceSerifProSemiBoldItalicTtf from './fonts/SourceSerifPro-SemiBoldItalic.ttf';
import SourceSerifProBoldTtf from './fonts/SourceSerifPro-Bold.ttf';
import SourceSerifProBoldItalicTtf from './fonts/SourceSerifPro-BoldItalic.ttf';
import SourceSerifProBlackTtf from './fonts/SourceSerifPro-Black.ttf';
import SourceSerifProBlackItalicTtf from './fonts/SourceSerifPro-BlackItalic.ttf';

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: breakpoints.xs,
      sm: breakpoints.sm,
      md: breakpoints.md,
      lg: breakpoints.lg,
      xl: breakpoints.xl,
    },
    step: 0,
  },
  palette: {
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.secondary,
    },
    error: {
      main: colors.error,
    },
    success: {
      main: colors.success,
    },
    text: {
      primary: colors.textHighContrast,
      secondary: colors.textMediumContrast,
      disabled: colors.dark60,
    },
    grey: {
      50: colors.neutral50,
      100: colors.neutral100,
      200: colors.neutral200,
      300: colors.neutral300,
      400: colors.neutral400,
      500: colors.neutral500,
      600: colors.neutral600,
      700: colors.neutral700,
      900: colors.neutral900,
    },
    divider: colors.dividerPrimary,
  },
  typography: {
    fontFamily: 'Manrope',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Manrope';
          font-style: normal;
          font-weight: 200;
          src: url(${ManropeExtraLightTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Manrope';
          font-style: normal;
          font-weight: 300;
          src: url(${ManropeLightTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Manrope';
          font-style: normal;
          font-weight: 400;
          src: url(${ManropeRegularTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Manrope';
          font-style: normal;
          font-weight: 500;
          src: url(${ManropeMediumTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Manrope';
          font-style: normal;
          font-weight: 600;
          src: url(${ManropeSemiBoldTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Manrope';
          font-style: normal;
          font-weight: bold;
          src: url(${ManropeBoldTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Manrope';
          font-style: normal;
          font-weight: 800;
          src: url(${ManropeExtraBoldTtf}) format('truetype');
        }
        @font-face {§
          font-family: 'Source Serif Pro';
          font-style: normal;
          font-weight: 200;
          src: url(${SourceSerifProExtraLightTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Source Serif Pro';
          font-style: italic;
          font-weight: 200;
          src: url(${SourceSerifProExtraLightItalicTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Source Serif Pro';
          font-style: normal;
          font-weight: 300;
          src: url(${SourceSerifProLightTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Source Serif Pro';
          font-style: italic;
          font-weight: 300;
          src: url(${SourceSerifProLightItalicTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Source Serif Pro';
          font-style: normal;
          font-weight: 400;
          src: url(${SourceSerifProRegularTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Source Serif Pro';
          font-style: italic;
          font-weight: 400;
          src: url(${SourceSerifProItaliccTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Source Serif Pro';
          font-style: normal;
          font-weight: 600;
          src: url(${SourceSerifProSemiBoldTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Source Serif Pro';
          font-style: italic;
          font-weight: 600;
          src: url(${SourceSerifProSemiBoldItalicTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Source Serif Pro';
          font-style: normal;
          font-weight: bold;
          src: url(${SourceSerifProBoldTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Source Serif Pro';
          font-style: italic;
          font-weight: bold;
          src: url(${SourceSerifProBoldItalicTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Source Serif Pro';
          font-style: normal;
          font-weight: 800;
          src: url(${SourceSerifProBlackTtf}) format('truetype');
        }
        @font-face {
          font-family: 'Source Serif Pro';
          font-style: italic;
          font-weight: 800;
          src: url(${SourceSerifProBlackItalicTtf}) format('truetype');
        }
      `,
    },
  },
});
